<template>
  <div class="body-2" data-test="klarna-third-party-advertisement">
    <RawKlarnaPlacement
      :base-price
      :data-key="settings.placementKey"
      :payment-method="klarnaPaymentMethod"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { usePaymentMethodsWithFallback } from '../../../methods'
import { useKlarnaLibrary } from '../../composables/useKlarnaLibrary'
import type { PaymentAdvertisingModalProps } from '../../types/PaymentAdvertisingModalProps'
import RawKlarnaPlacement from '../KlarnaBanner/RawKlarnaPlacement.vue'

import {
  KLARNA_ADVERTISEMENT_SETTINGS,
  KLARNA_PAYMENT_METHODS,
} from './KlarnaThirdPartyAdvertisement.config'

const props = withDefaults(defineProps<PaymentAdvertisingModalProps>(), {
  name: 'KlarnaThirdPartyAdvertisement',
  paymentMethods: null,
})

const settings = computed(() => KLARNA_ADVERTISEMENT_SETTINGS[props.spot])
const paymentMethods = usePaymentMethodsWithFallback(() => props.paymentMethods)

const klarnaPaymentMethod = computed(() => {
  const paymentMethod = paymentMethods.value.find(({ bmCode }) =>
    KLARNA_PAYMENT_METHODS.includes(bmCode),
  )

  if (!paymentMethod) {
    throw new Error('Could not find any Klarna payment method')
  }

  return paymentMethod
})

useKlarnaLibrary(klarnaPaymentMethod.value)
</script>
